import type { i18n as i18nType, TOptions } from 'i18next';
import { useTranslation } from 'react-i18next';

export type Translator<TranslationKeys extends string> = (key: TranslationKeys, option?: TOptions) => string;

interface TypedTranslationUtils<TranslationKeys extends string> {
    i18n: i18nType;
    t: Translator<TranslationKeys>;
    language: 'en' | 'fr';
}

export function useNecTranslations<TranslationKeys extends string = string>(): TypedTranslationUtils<TranslationKeys> {
    const { t, i18n } = useTranslation();
    return {
        i18n,
        t,
        get language() {
            return i18n.language.toLowerCase().startsWith('en') ? 'en' : 'fr';
        },
    };
}
